<template>
  <div class="common-date-status">
    <common-slide-calendar
      class="bg-FFFFFF"
      @getDate="methodGetDate"
      :with-status="true"
      :status-list="dateExceed ? [] : statusList"
      timeFormat="YYYYMMDD"
      :default-date="computedDate"
      @changeCalendarType="changeCalendarType"
      @onTransitionEnd="onTransitionEnd"
      ref="calendar"
    >
      <div
        slot="title"
        class="p-16-0 bb fb fb-cross-center c-171A1D font-28 p-0-16"
      >
        <span>{{ computedTimeStr }}</span>
      </div>
    </common-slide-calendar>
    <div
      class="bg-FFFFFF p-0-16 font-28 pt-16"
      ref="leaveList"
      v-if="askForLeave.length && !dateExceed"
    >
      <div class="bd-radio-4 hidden">
        <div
          class="fb fb-main-between p-12-0 pl-12 fb-cross-center bg-F9F9F9"
          :class="{ bt: index > 0 }"
          v-for="(item, index) in askForLeave"
          @click="handlerRouter(item)"
          :key="index"
        >
          <div class="fb fb-cross-baseline font-34">
            <span class="iconfont c-FF9F00 mr-7">&#xe688;</span>
            <div>
              <div class="fb fb-cross-center">
                <span class="c-171A1D ff-medium lh-24 mb-4"
                  >{{ item.leaveTypeName }}
                </span>
                <span class="ml-4 c-171A1D-60"
                  >({{
                    `${parseFloat(item.leaveDuration).toFixed(1)}${
                      item.leaveDurationUnit === 1 ? '小时' : '天'
                    }`
                  }})</span
                >
              </div>
              <p class="font-26 c-171A1D-56">{{
                methodTransfromTime(item)[0]
              }}</p>
            </div>
          </div>
          <span class="iconfont font-28 c-171A1D-40 mr-20">&#xe66b;</span>
        </div>
      </div>
    </div>
    <div
      ref="stepList"
      class="bg-FFFFFF pt-20 pl-22 pr-16"
      v-if="list.length && !dateExceed"
    >
      <div class="detail-content" v-for="(item, index) in list" :key="index">
        <common-step :show-line="index !== list.length - 1" :icon="1" class="">
          <span slot="title">
            <span class="pl-8 text-bold">
              <span class="pr-8 p-4-0 ff-medium">{{
                item.status === 1 ? '在校' : '离校'
              }}</span>
              <span class="p-4-0">{{
                timeFormat(new Date(item.accessTime), 'hh:mm')
              }}</span>
            </span>
          </span>
          <div slot="main" class="pl-10 pb-50">
            <div
              v-if="item.deviceName"
              class="font-26 pl-12 fb fb-cross-center c-171A1D-56 mt-12"
            >
              <i class="iconfont font-32 mr-5">&#xe689;</i>
              <span>{{ item.deviceName }}</span>
            </div>
            <div v-if="item.catchImageUrl" class="pl-12 mt-12">
              <div class="w-50 h-50 bd-radio-4 hidden">
                <img
                  width="50"
                  :src="item.catchImageUrl"
                  @click="enlargeImgUrl = item.catchImageUrl"
                />
              </div>
            </div>
            <div
              v-if="item.modifyRecord"
              class="font-26 pl-12 c-171A1D-56 mt-12"
            >
              <div>{{
                `${item.modifyRecord.operatorUserName} 在 ${timeFormat(
                  new Date(item.modifyRecord.gmtCreate),
                  'YYYY-MM-DD hh:mm'
                )} 将状态调整为${
                  item.modifyRecord.newStatus === 1 ? '在校' : '离校'
                }`
              }}</div>
              <div class="mt-4" v-if="item.modifyRecord.reason">{{
                `备注：${item.modifyRecord.reason}`
              }}</div>
            </div>
          </div>
        </common-step>
      </div>
    </div>
    <div
      class="noData fb fb-main-center fb-cross-center text-center bg-FFFFFF"
      v-if="dateExceed"
      :style="{ height: `${tipsHeight}px` }"
    >
      <div class="fb fb-col c-171A1D-40">
        <span class="iconfont font-140 c-171A1D-12">&#xe68b;</span>
        <p class="font-26 mt-16 text-center mt-16">超出可查看的统计日期范围</p>
      </div>
    </div>
    <template v-else>
      <div
        class="noData fb fb-main-center fb-cross-center text-center bg-FFFFFF"
        v-if="!list.length"
        :style="{ height: `${tipsHeight}px` }"
      >
        <div class="fb fb-col c-171A1D-40">
          <span class="iconfont font-140 c-171A1D-12">&#xe68b;</span>
          <p class="font-26 mt-16 text-center mt-16">当天暂无在校记录</p>
        </div>
      </div>
    </template>
    <commonImgEnlarge
      :img="enlargeImgUrl"
      v-model="enlargeImgUrl"
    ></commonImgEnlarge>
  </div>
</template>
<script>
import commonSlideCalendar from './commonSlideCalendar'
import commonImgEnlarge from './commonImgEnlarge'
import {
  unitDayTime,
  debounce,
  timeFormat,
  timeStrToDate
} from '@/utils/comUtils'
import {} from '@/utils/mcSdkUtils'
import API from '../api'
import commonStep from './commonStep'
import mixin from '@/mixin'
export default {
  mixins: [mixin],
  props: {
    student: {
      // 学生信息
      type: Object,
      default: () => {
        return {}
      }
    },
    dimDay: {
      type: String,
      default: timeFormat(new Date(), 'YYYYMMDD')
    },
    height: {
      type: Number,
      default: 200
    }
  },
  components: {
    commonSlideCalendar,
    commonImgEnlarge,
    commonStep
  },
  computed: {
    computedTimeStr() {
      return timeFormat(this.startDate, 'YYYY年MM月')
    },
    computedDate() {
      return timeStrToDate(this.dimDay)
    }
  },
  watch: {
    selectedDate: {
      immediate: true,
      handler(val) {
        this.getUserReport()
        this.$parent.isCurrenDay = timeFormat(new Date(), 'YYYYMMDD') === val
      }
    }
  },
  data() {
    return {
      timeFormat,
      enlargeImgUrl: '',
      list: [],
      askForLeave: [],
      statusList: [],
      selectedDate: this.dimDay,
      calendarType: 0,
      tipsHeight: 240,
      startDate: new Date(),
      dateExceed: false
    }
  },
  methods: {
    // 跳转页面
    handlerRouter(item) {
      this.$router.push({
        path: '/leave/detail',
        query: {
          leaveId: item.leaveId
        }
      })
    },
    // 时间格式化
    methodTransfromTime(time) {
      let _time = []
      if (+time.leaveDurationUnit === 2) {
        let _start = new Date(time.start.replace(/-/gi, '/'))
        let _end = new Date(time.end.replace(/-/gi, '/'))
        let _unitDayTime = unitDayTime(+_start, +_end)
        let _seg = ((_end - _start) / (24 * 60 * 60 * 1000)).toFixed(1)
        _time[0] = `${_unitDayTime[0]}～${_unitDayTime[1]}`
        _time[1] = `${_seg}天`
      } else {
        let _start = time.start.replace(/-/g, '.')
        let _end = time.end.replace(/-/g, '.')
        const _HOURS = (time.period / 60).toFixed(1)
        _time[0] = `${_start}～${_end}`
        _time[1] = `${_HOURS}小时`
      }

      return _time
    },
    // 判断是否有打卡记录，以便显示是否需要显示打卡机
    methodGetDate(date) {
      this.selectedDate = date
    },
    onTransitionEnd({ date, calendarType, exceed }) {
      this.calendarType = calendarType
      this.startDate = new Date(date.slice(0, 4), +date.slice(4, 6) - 1, 1)
      this.dateExceed = exceed
      this.setHeight()
      if (exceed) {
        return
      }
      if (date.slice(0, 6) !== this.selectedDate.slice(0, 6)) {
        this.selectedDate = date
      }
      debounce(this.getUserCalendar)()
    },
    getUserCalendar(dimDate = this.selectedDate) {
      let _yearMonth = this.selectedDate
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      let day = `0${new Date().getDate()}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}${day}` ||
        +_yearMonth > +`${year}${month}${day}`
      ) {
        return false
      }
      let startDate = timeStrToDate(dimDate)
      let endDate = new Date(startDate.getTime())
      if (this.calendarType === 1) {
        endDate.setMonth(endDate.getMonth() + 1)
        endDate.setDate(0)
        startDate.setDate(1)
      } else {
        startDate.setDate(
          startDate.getDate() -
            (startDate.getDay() === 1 ? 0 : startDate.getDay() - 1)
        )
        endDate = new Date(startDate.getTime())
        endDate.setDate(endDate.getDate() + 6)
      }
      API.getStudentDailyStatusList({
        ...this.commonParams2,
        studentMemberId: this.student.memberId,
        startDimDay: timeFormat(startDate, 'YYYYMMDD'),
        endDimDay: timeFormat(endDate, 'YYYYMMDD')
      })
        .then(res => {
          this.statusList = res || []
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    changeCalendarType({ date, calendarType, startDate, exceed }) {
      this.selectedDate = date
      this.calendarType = calendarType
      this.startDate = new Date(
        startDate.slice(0, 4),
        +startDate.slice(4, 6) - 1,
        1
      )
      this.setHeight()
      this.dateExceed = exceed
      if (exceed) {
        return
      }
      debounce(this.getUserCalendar)()
    },
    getUserReport(date = this.selectedDate) {
      let _yearMonth = this.selectedDate
      let year = new Date().getFullYear()
      let month = `0${new Date().getMonth() + 1}`.slice(-2)
      let day = `0${new Date().getDate()}`.slice(-2)
      if (
        +_yearMonth < +`${year - 1}${month}${day}` ||
        +_yearMonth > +`${year}${month}${day}`
      ) {
        return false
      }
      API.getStudentAccessRecords({
        ...this.commonParams2,
        dimDay: date,
        studentMemberId: this.student.memberId
      })
        .then(res => {
          let result = res || {}
          this.askForLeave = result.leaves || []
          this.list = result.records || []
          this.$set(this.$parent.student, 'status', result.status)
          this.setHeight()
        })
        .catch(err => {
          console.log('unhandledrejection', err)
        })
    },
    setHeight() {
      this.$nextTick(() => {
        let timeListHeight = (this.$refs.timeList || {}).clientHeight || 0
        let leaveListHeight = (this.$refs.leaveList || {}).clientHeight || 0
        let stepListHeight = (this.$refs.stepList || {}).clientHeight || 0
        this.tipsHeight = Math.min(
          this.height -
            this.$refs.calendar.$el.offsetHeight -
            10 -
            timeListHeight -
            leaveListHeight -
            stepListHeight,
          240
        )
      })
    }
  },
  mounted() {
    this.getUserCalendar()
  }
}
</script>
<style lang="scss" scoped>
.noData img,
.haveARest img {
  margin: 0 auto;
  height: 60px;
  width: 60px;
}
.line-left {
  display: inline-block;
  border-left: 2px solid #b4b4b4;
  position: absolute;
  top: 7px;
  left: -1px;
  z-index: 1;
  width: 2px;
  height: 100%;
}
.detail-tag {
  top: 0px;
  left: -7px;
  z-index: 2;
}
.detail-inner-tag {
  top: 0;
  left: -4px;
  z-index: 2;
}
// .detail-content:last-child {
//   .detail-box:last-child {
//     .line-left {
//       display: none;
//     }
//   }
// }
.tag-abnormal {
  background: #fdf2de;
  color: #ff9f00;
}
.tag-normal {
  background: #def5e9;
  color: #00b853;
}
.modifyEnd {
  display: inline-block;
  padding: 3px 8px;
  border: 1px solid;
}
</style>
